import styled from 'styled-components';

export const MetricsContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    min-height: 0;
`;

export const MetricsContent = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`;

export const MetricsHeader = styled.div`
    height: 60px;
    padding: 0 24px;
    border-bottom: 1px solid var(--color-border, #e5e7eb);
    background: var(--color-background, white);
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

export const HeaderRight = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const SearchContainer = styled.div`
    position: relative;
    width: 300px;
    flex-shrink: 0;

    input {
        border-radius: 9999px;
        padding-left: 2.5rem;
        height: 36px;
        font-size: 14px;
        background-color: #f9fafb;
        border-color: #e5e7eb;

        &:focus {
            background-color: white;
        }

        &::placeholder {
            color: #9ca3af;
        }
    }
`;

export const SearchIcon = styled.div`
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
    pointer-events: none;
    z-index: 1;
`;

export const ContentContainer = styled.div`
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
`;
